import { motion } from 'framer-motion';
import styles from './MissedShutdownBanner.module.css';

interface MissedShutdownBannerProps {
  yesterdayDate: string;
  onNavigateToShutdown: () => void;
  onDismiss: () => void;
}

export function MissedShutdownBanner({
  onNavigateToShutdown,
  onDismiss,
}: MissedShutdownBannerProps) {
  return (
    <motion.div
      className={styles.banner}
      initial={{ height: 0, opacity: 0 }}
      animate={{ height: 'auto', opacity: 1 }}
      exit={{ height: 0, opacity: 0 }}
      transition={{ duration: 0.2 }}
    >
      <div className={styles.message}>
        <span className={styles.icon}>⚠</span>
        <span>You didn't complete yesterday's shutdown ritual.</span>
      </div>
      <div className={styles.actions}>
        <button className={styles.completeBtn} onClick={onNavigateToShutdown}>
          Complete Now
        </button>
        <button className={styles.dismissBtn} onClick={onDismiss}>
          Dismiss
        </button>
      </div>
    </motion.div>
  );
}
